<template>
    <div>
        <table :class="['table', this.small && 'table-sm', this.stripped && 'table-striped','my-border']">
            <thead v-if="header"><tr><th colspan="2">Aktuální akce</th></tr></thead>
            <tbody>
            <tr v-for="event in filtered()" v-bind:key="event.date">
<!--                <th scope="row" maxWidth="120"> <s>{{event.date}} </s></th>-->
<!--                <td scope="row" style="text-align: left"> <s>{{event.name}} </s></td>-->
                <th scope="row" maxWidth="120">{{event.date}}</th>
                <td scope="row" style="text-align: left">{{event.name}}</td>
            </tr>
            </tbody>
        </table>
        <div class="image_caption text-center">
          <img src="/actual_poster_4.9.jpg" class="img-fluid" style="margin-top:2em" alt="Responsive image">
          <h2 class="caption overtext my-overstrip">Přerušno</h2>
<!--          <h3>...</h3>-->
<!--          <p class="carousel-caption">Some text here </p>-->
        </div>


    </div>
</template>

<script>
    export default {
        props: {
            events: {required: false},
            small: {required: false},
            stripped: {required: false},
            header: {required: false},
            start: {required: false}
        },
        methods:{
            parseLocalDate:function (dateString) {
                if(dateString){
                    let dateParser = /(\d{1,2}) ?. ?(\d{1,2}) ?. ?(\d{4})/;
                    let match = dateString.match(dateParser);
                    let date = new Date(
                        match[3],  // year
                        match[2]-1,  // monthIndex
                        match[1],  // day
                    );
                    return date;
                }
            },
            testDate:function(dateA,dateB){
                if(dateA && dateB){
                    return this.parseLocalDate(dateA) >= this.parseLocalDate(dateB)
                }
                return true;
            },
            getData: function () {
                let vm = this;
                // eslint-disable-next-line no-undef
                axios.get('/events.json')
                    .then(function (response) {
                        // eslint-disable-next-line no-undef
                        vm.events_loaded = response.data;
                        // console.log(JSON.parse(response.data));
                    })
                    .catch(function (error) {
                        console.error('Load error' + error.status);
                    })
            },
            filtered:function() {
                // console.log(this.events_loaded);
                // console.log(Array.isArray(this.events_loaded));
                if(Array.isArray(this.events_loaded)){
                    return this.events_loaded.filter(evt => this.testDate(evt.date,this.start))
                }else if(this.events_loaded === String){
                    // console.log(this.events_loaded);
                    return JSON.parse(this.events_loaded).filter(evt => this.testDate(evt.date,this.start))
                }
            }
        },
        data: function () {
            return {
                events_loaded:[],
                // akce: this.events.filter(evt => this.testDate(evt.date,this.start)),
            }

        },
        beforeMount(){
            this.getData();
            if(this.events_loaded===undefined || Object.keys(this.events_loaded).length === 0){
                // console.log(this.events_loaded);
                this.events_loaded = this.events;
            }
        },
    }
</script>
<style>
    .my-border {
        border: 0 solid #dee2e6;
        border-top-width: 1px;
    }
    .my-overstrip {
        border: 0 solid #dee2e6e0;
        border-top-width: 1px;
        background-color: #dee2e6e0;
    }
    .caption {
       position: absolute;
       top: 50%;
       left: -7%;
       width: 114%;
     }
    .overtext{
      color: RED;
      font-weight: bold;
      transform: rotate(-19deg);
      /* Legacy vendor prefixes that you probably don't need... */
      -webkit-transform: rotate(-19deg);
      -moz-transform: rotate(-19deg);
      -ms-transform: rotate(-19deg);
      -o-transform: rotate(-19deg);
    }

    .image_caption{
      position: relative;
    }
</style>